<template>
  <v-app
    :class="{ 'has-pwa-update': updateAvailable }"
    :style="{ backgroundColor: $vuetify.theme.themes.dark.background }"
  >
      <router-view/>
      <transition name="lema-update-panel">
        <aside
          v-if="updateAvailable"
          class="lema-update-dock"
          role="status"
          aria-live="polite"
          aria-label="نسخه جدید برنامه آماده است"
        >
          <span class="lema-update-dock__icon" aria-hidden="true">
            <v-icon>mdi-update</v-icon>
          </span>
          <span class="lema-update-dock__message">
            <strong>نسخه جدید آماده است</strong>
            <small>برای اعمال آخرین تغییرات، برنامه را به‌روزرسانی کنید.</small>
          </span>
          <button type="button" class="lema-update-dock__action" @click="installUpdate">
            <v-icon aria-hidden="true">mdi-download-outline</v-icon>
            <span>به‌روزرسانی</span>
          </button>
          <button
            type="button"
            class="lema-update-dock__dismiss"
            aria-label="بستن پیام به‌روزرسانی"
            title="بستن"
            @click="dismissUpdate"
          >
            <v-icon aria-hidden="true">mdi-close</v-icon>
          </button>
        </aside>
      </transition>
      <v-snackbar
        v-model="offline"
        class="lema-system-snackbar"
        :class="{ 'lema-system-snackbar--raised': updateAvailable }"
        content-class="lema-system-snackbar__content"
        app
        bottom
        :timeout="5000"
        color="#6f501c"
      >
        اتصال اینترنت قطع است. اطلاعات آنلاین ممکن است به‌روز نباشد.
      </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({ updateAvailable: false, offline: !navigator.onLine, waitingRegistration: null }),
  mounted() {
    window.addEventListener('lema:pwa-update', this.onUpdate);
    window.addEventListener('lema:pwa-offline', this.onOffline);
    window.addEventListener('online', this.onOnline);
    window.addEventListener('offline', this.onOffline);
  },
  beforeDestroy() {
    window.removeEventListener('lema:pwa-update', this.onUpdate);
    window.removeEventListener('lema:pwa-offline', this.onOffline);
    window.removeEventListener('online', this.onOnline);
    window.removeEventListener('offline', this.onOffline);
  },
  methods: {
    onUpdate(event) { this.waitingRegistration = event.detail; this.updateAvailable = true; },
    onOffline() { this.offline = true; },
    onOnline() { this.offline = false; },
    dismissUpdate() { this.updateAvailable = false; },
    installUpdate() {
      const worker = this.waitingRegistration && this.waitingRegistration.waiting;
      if (!worker) { window.location.reload(); return; }
      navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
      worker.postMessage({ type: 'SKIP_WAITING' });
    },
  },
};
</script>
<style>

#app {
    height: 100%;
    touch-action: manipulation;
    

}

.lema-system-snackbar.v-snack--bottom {
    bottom: calc(88px + env(safe-area-inset-bottom, 0px) + 12px) !important;
    z-index: 30 !important;
}

.lema-system-snackbar--raised.v-snack--bottom {
    bottom: calc(170px + env(safe-area-inset-bottom, 0px) + 12px) !important;
}

.lema-system-snackbar .v-snack__wrapper {
    width: calc(100% - 24px);
    min-width: 0;
    max-width: 552px;
    margin: 0 auto;
    border: 1px solid rgba(119, 215, 210, 0.32);
    border-radius: 8px;
    box-shadow: 0 14px 34px rgba(3, 10, 20, 0.36);
}

.lema-system-snackbar__content {
    min-height: 66px !important;
    padding: 10px 12px !important;
    font-family: inherit;
    direction: rtl;
}

.has-pwa-update .layout-content {
    padding-bottom: 82px;
}

.lema-update-dock {
    position: fixed;
    right: 0;
    bottom: calc(88px + env(safe-area-inset-bottom, 0px));
    left: 0;
    z-index: 24;
    display: grid;
    width: 100%;
    min-height: 82px;
    max-width: 576px;
    grid-template-columns: 42px minmax(0, 1fr) auto 34px;
    align-items: center;
    gap: 10px;
    margin: 0 auto;
    padding: 11px 14px;
    border: 1px solid rgba(119, 215, 210, 0.42);
    border-bottom: 0;
    border-radius: 8px 8px 0 0;
    background: #0d2a36;
    box-shadow: 0 -12px 30px rgba(3, 10, 20, 0.34);
    color: #f7ffff;
    direction: rtl;
    isolation: isolate;
    opacity: 1;
}

.lema-update-dock__icon {
    display: grid;
    width: 40px;
    height: 40px;
    place-items: center;
    border-radius: 8px;
    background: rgba(119, 215, 210, 0.14);
}

.lema-update-dock__icon .v-icon {
    color: #7ce0dc;
    font-size: 24px;
}

.lema-update-dock__message {
    display: flex;
    min-width: 0;
    flex-direction: column;
}

.lema-update-dock__message strong {
    color: #ffffff;
    font-size: 12px;
    font-weight: 900;
    line-height: 1.6;
}

.lema-update-dock__message small {
    margin-top: 2px;
    color: #b7cbd2;
    font-size: 9px;
    line-height: 1.7;
}

.lema-update-dock__action,
.lema-update-dock__dismiss {
    min-height: 40px;
    border-radius: 7px;
    font-family: inherit;
    cursor: pointer;
}

.lema-update-dock__action {
    display: inline-flex;
    min-width: 104px;
    padding: 0 12px;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border: 1px solid #7ce0dc;
    background: #7ce0dc;
    color: #071923;
    font-size: 10px;
    font-weight: 900;
}

.lema-update-dock__action .v-icon {
    color: inherit;
    font-size: 18px;
}

.lema-update-dock__dismiss {
    display: grid;
    width: 34px;
    min-width: 34px;
    padding: 0;
    place-items: center;
    border: 1px solid rgba(183, 203, 210, 0.24);
    background: transparent;
    color: #b7cbd2;
}

.lema-update-dock__dismiss .v-icon {
    color: inherit;
    font-size: 18px;
}

.lema-update-dock__action:focus-visible,
.lema-update-dock__dismiss:focus-visible {
    outline: 3px solid rgba(124, 224, 220, 0.28);
    outline-offset: 2px;
}

.lema-update-panel-enter-active,
.lema-update-panel-leave-active {
    transition: opacity 160ms ease, transform 180ms ease;
}

.lema-update-panel-enter,
.lema-update-panel-leave-to {
    opacity: 0;
    transform: translateY(12px);
}

@media (max-width: 370px) {
    .lema-update-dock {
        min-height: 72px;
        grid-template-columns: 38px minmax(0, 1fr) 94px 30px;
        gap: 7px;
        padding: 9px 10px;
    }

    .has-pwa-update .layout-content {
        padding-bottom: 72px;
    }

    .lema-update-dock__message small {
        display: none;
    }

    .lema-update-dock__action {
        min-width: 94px;
        padding: 0 8px;
    }

    .lema-update-dock__dismiss {
        width: 30px;
        min-width: 30px;
    }
}
</style>
